// extracted by mini-css-extract-plugin
export default {"overlay":"loader_overlay__zpUX6"};